export enum BootstrapError {
  MISSING_ESTABLISHMENT = 'MISSING_ESTABLISHMENT',
  ESTABLISHMENT_IS_SUSPENDED = 'ESTABLISHMENT_IS_SUSPENDED',
  MISSING_PURCHASE = 'MISSING_PURCHASE',
  DISH_PROCESSQUEUE_TIMEOUT = 'DISH_PROCESSQUEUE_TIMEOUT',
  FAILED_AUTHENTICATION = 'FAILED_AUTHENTICATION',
}
